import React, { memo } from 'react';
import moment from 'moment';

export const DateCell = memo(({ article }) => {
	return (
		<div>
			{moment(article.availableAt).format('HH:mm')}
			<br />
			{moment(article.availableAt).format('DD.MM.YYYY')}
		</div>
	);
});



// WEBPACK FOOTER //
// src/components/articles/columns/date.js